import { useQuery } from "@apollo/client";
import { Autocomplete, FormControl, TextField } from "@mui/material";
import { gql } from "generated-graphql";

const TENANT_WASTE_INVOICE_VENDORS_QUERY = gql(`
  query TenantWasteInvoiceVendors($tenantId: ID!) {
    tenantWasteInvoiceVendors(tenantId: $tenantId)
  }
`);

type WasteInvoiceVendorPickerProps = {
  /** Scopes the vendor option list to a single tenant. */
  tenantId?: string;
  label?: string;
  disabled?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  value: string | null;
  onChange: (value: string | null) => void;
};

/** Selects one vendor from the tenant's waste invoices. */
export default function WasteInvoiceVendorPicker(props: WasteInvoiceVendorPickerProps) {
  const { tenantId, value, onChange, label, disabled, onOpen, onClose } = props;
  const { data, loading } = useQuery(TENANT_WASTE_INVOICE_VENDORS_QUERY, {
    variables: { tenantId: tenantId ?? "" },
    skip: !tenantId,
  });
  const options = data?.tenantWasteInvoiceVendors ?? [];

  return (
    <FormControl fullWidth>
      <Autocomplete
        size="small"
        options={options}
        value={value}
        loading={loading}
        disabled={disabled}
        onChange={(_, newValue) => onChange(newValue)}
        onOpen={onOpen}
        onClose={onClose}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={!value ? "Select..." : ""}
            autoComplete="off"
            inputProps={{
              ...params.inputProps,
              autoComplete: "off",
              "data-lpignore": "true",
              "data-form-type": "other",
            }}
          />
        )}
      />
    </FormControl>
  );
}
